import { MessageCircle, Heart, Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ArticleStatsProps {
  commentCount: number;
  reactionCount: number;
  zapCount: number;
  zapTotal: number;
  isLoading?: boolean;
  onCommentsClick?: () => void;
  className?: string;
}

export function ArticleStats({
  commentCount,
  reactionCount,
  zapCount,
  zapTotal,
  isLoading,
  onCommentsClick,
  className,
}: ArticleStatsProps) {
  const stat = (value: string) => (isLoading ? '—' : value);

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground',
        className,
      )}
    >
      <button
        type="button"
        onClick={onCommentsClick}
        className="inline-flex items-center gap-2 transition-colors hover:text-primary focus-visible:outline-none focus-visible:text-primary"
      >
        <MessageCircle className="h-4 w-4" />
        <span>
          {stat(String(commentCount))}{' '}
          <span className="hidden sm:inline">
            {commentCount === 1 ? 'comment' : 'comments'}
          </span>
        </span>
      </button>

      <span className="inline-flex items-center gap-2">
        <Heart className="h-4 w-4 text-rose-400" />
        <span>
          {stat(String(reactionCount))}{' '}
          <span className="hidden sm:inline">
            {reactionCount === 1 ? 'reaction' : 'reactions'}
          </span>
        </span>
      </span>

      <span className="inline-flex items-center gap-2">
        <Zap className="h-4 w-4 text-amber-400" />
        <span>
          {stat(String(zapCount))}{' '}
          <span className="hidden sm:inline">
            {zapCount === 1 ? 'zap' : 'zaps'}
          </span>
          {zapTotal > 0 && (
            <span className="text-amber-400/90">
              {' '}
              · {zapTotal.toLocaleString()} sats
            </span>
          )}
        </span>
      </span>
    </div>
  );
}
